import { render, staticRenderFns } from "./BaseTabsSelect.vue?vue&type=template&id=81ea9f94"
import script from "./BaseTabsSelect.vue?vue&type=script&lang=js"
export * from "./BaseTabsSelect.vue?vue&type=script&lang=js"
import style0 from "./BaseTabsSelect.vue?vue&type=style&index=0&id=81ea9f94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports